import request from '@/util/request'

// 查询农产品分类列表
export function getProductTypeList () {
  return request({
    method: 'post',
    url: '/api/productTypeList',
  })
}

// 查询农产品详情列表
export function getProductsInfoList (data) {
  return request({
    method: 'post',
    url: '/api/productsInfoList',
    params: data,
  })
}

// 获取农产品详情信息
export function getProductsInfo (data) {
  return request({
    method: 'post',
    url: '/api/getProductsInfo',
    params: data,
  })
}

// 查询农产品需求列表
export function getPurchaserProductsList (data) {
  return request({
    method: 'post',
    url: '/api/purchaserProductsList',
    data,
  })
}

// 获取农产品需求详细信息
export function getPurchaserProductsInfo (data) {
  return request({
    method: 'post',
    url: '/api/getPurchaserProductsInfo',
    data,
  })
}